import React, { ComponentProps, useEffect, useState } from "react";
import * as RadixSwitch from "@radix-ui/react-switch";
import styles from "./Switch.module.scss";
import clsx from "clsx";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  name: string;
  label: string;
}

const Switch: React.FC<Props> = ({
  checked: propChecked,
  onCheckedChange,
  name,
  label,
  className,
}) => {
  const [checked, setChecked] = useState(propChecked || false);

  useEffect(() => {
    if (!onCheckedChange) return;
    onCheckedChange(checked);
  }, [checked]);

  return (
    <div className={clsx(styles.container, className)}>
      <RadixSwitch.Root
        checked={checked}
        onCheckedChange={setChecked}
        className={styles.switch}
        id={name}
      >
        <RadixSwitch.Thumb className={styles.thumb} />
      </RadixSwitch.Root>
      <label className={styles.label} htmlFor={name}>
        {label}
      </label>
    </div>
  );
};

export default Switch;
